import {
  HTTP_INTERCEPTORS,
  HttpHandler,
  HttpHeaderResponse,
  HttpInterceptor,
  HttpProgressEvent,
  HttpRequest,
  HttpResponse,
  HttpSentEvent,
  HttpUserEvent,
} from '@angular/common/http';
import { forwardRef, inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { SessionInterface, SessionService } from './session.service';

export const CONFIGURATOR_SESSION_CONFIGURATION_IDENTIFIER_HEADER_KEY = 'X-PriceList7-Configurator-Session-Configuration-Identifier';

export const CONFIGURATOR_SESSION_INTERCEPTOR_PROVIDER = {
  provide: HTTP_INTERCEPTORS,
  useClass: forwardRef(() => SessionInterceptor),
  multi: true,
};

@Injectable()
export class SessionInterceptor implements HttpInterceptor {
  private session = inject(SessionService);

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpSentEvent | HttpHeaderResponse | HttpProgressEvent | HttpResponse<any> | HttpUserEvent<any>> {
    const excludedEndpoint = /\/suggested-articles\/\d+\/apply/;

    const parsedSession: SessionInterface = this.session.latestFromStorage();
    if (parsedSession && parsedSession.session && !excludedEndpoint.test(req.url)) {
      const headers = {};
      headers[CONFIGURATOR_SESSION_CONFIGURATION_IDENTIFIER_HEADER_KEY] = parsedSession.session;

      req = req.clone({
        setHeaders: headers,
      });
    }

    return next.handle(req).pipe(tap((_) => {}));
  }
}
